import TimeTracQIcon from "@/assets/timetracq.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const TimeTracQLogo = (props: Props) => (
  <LogoImage imgSrc={TimeTracQIcon} alt="TimeTracQ Logo" size="navbar" {...props} />
);
